<template>
  <el-pagination
    layout="prev, pager, next"
    hide-on-single-page
    background
    v-bind="$attrs"
    v-on="$listeners"
  />
</template>

<script>
  export default {
  }
</script>

<style lang="scss" scoped>
  @import "../../scss/_colors.scss";

  .el-pagination {
    text-align: initial;
  }

  ::v-deep .el-pager li {
    font-size: 12px;
    color: $dark-blue-2;
    font-weight: normal;

    &.active {
      font-weight: 800;
      color: $blue;
    }
  }
</style>
